import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    // Remove ng-version to be exposed due to pen-test recommendation
    const rootEl = document.querySelector('[ng-version]');
    if (rootEl) {
      rootEl.removeAttribute('ng-version');
    }
  })
  .catch(err => console.error(err));
